export class ApiError extends Error {
    public code: number;
    public override message: string;

    constructor(message: string, code: number = 500) {
        super(message);
        this.name = 'ApiError';
        this.code = code;
        this.message = message;
        
        // Maintains proper stack trace for where our error was thrown (only available on V8)
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ApiError);
        }
    }

    static fromFetchError(error: any): ApiError {
        const code = error.response?.status || error.status || error.statusCode || 500;
        const message = error.data?.message || error.message || 'An error occurred';
        return new ApiError(message, code);
    }
} 